// extracted by mini-css-extract-plugin
export var animationContainer = "_ho-0";
export var asteriskIcon = "_ho-8";
export var conversationLeftSection = "_ho-4";
export var conversationListItem = "_ho-3";
export var conversationMiddleSection = "_ho-5";
export var conversationRightSection = "_ho-6";
export var detailsContent = "_ho-1";
export var listContainer = "_ho-7";
export var modalContent = "_ho-2";